/* Mer-Rubbelkarte für das Klaviyo-Pop-up.
 * Klaviyo-Formulare führen kein eigenes Skript aus. Darum liegt dieses Skript im Shop-Theme
 * und sucht das Bild mit alt="Mer-Rubbelkarte" (oder einem anderen Namen aus KARTEN) im Pop-up. Ohne Skript bleibt das Bild
 * antippbar (Klaviyo: Klick → nächster Schritt).
 * Ablauf: Canvas über das Bild legen, Folie hineinmalen, darunter die Gewinnkarte zeigen,
 * mit dem Finger freirubbeln. Ab ~55 % frei: Folie ausblenden, dann den Knopf „Karte aufdecken“
 * (CSS-Klasse mer-rubbel-weiter) drücken → Klaviyo geht zum nächsten Schritt. Bilder können in
 * Klaviyo nicht „weiter“, darum der Knopf. Das Skript blendet ihn aus; ohne Skript bleibt er sichtbar.
 */
(function () {
  // Alt-Text der Folie im Pop-up → Gewinnkarte darunter. Der A/B-Test des Pop-ups wählt so die Karte:
  // A „Mer-Rubbelkarte“ = Überraschungs-Rabatt, B „Mer-Rubbelkarte-5euro“ = 5 € Rabatt.
  var KARTEN = {
    "Mer-Rubbelkarte": window.MER_RUBBEL_GEWINN ||       // rubbel-gewinn.png in der Mer-Klaviyo-Bibliothek
      "https://cdn.klaviyomail.com/company/RZJart/images/e3cdab2a-b018-48a9-ac4a-31278b804e4c.png",
    "Mer-Rubbelkarte-5euro":                              // karte-5euro.png (mer-popup-v4-karte-5euro)
      "https://cdn.klaviyomail.com/company/RZJart/images/6d59f89a-a2b0-4400-bfb5-3ff1c7831f40.png",
    "Mer-Rubbelkarte-it":                                 // it-rubbel-gewinn.png (Pop-up IT, Variante A)
      "https://cdn.klaviyomail.com/company/RZJart/images/ed107751-777f-4493-a330-124c46636c2f.png",
    "Mer-Rubbelkarte-5euro-it":                           // it-karte-5euro.png (Pop-up IT, Variante B)
      "https://cdn.klaviyomail.com/company/RZJart/images/05c53678-3255-4a8d-b1c5-1016298fc6a4.png",
    "Mer-Rubbelkarte-fr":                                 // fr-rubbel-gewinn.png (Pop-up FR, Variante A)
      "https://cdn.klaviyomail.com/company/RZJart/images/31042bfd-6dd3-45ef-bb20-baf1fcb41e9e.png",
    "Mer-Rubbelkarte-5euro-fr":                           // fr-karte-5euro.png (Pop-up FR, Variante B)
      "https://cdn.klaviyomail.com/company/RZJart/images/dadf7179-3373-4b7a-affc-0430b1d9a4d1.png"
  };
  var FERTIG_AB = 0.55, RASTER_X = 20, RASTER_Y = 14;

  function weiterKnopf(img) {
    var form = img.closest(".klaviyo-form") || document;
    var k = form.querySelector(".mer-rubbel-weiter");
    if (k && k.tagName !== "BUTTON") k = k.querySelector("button") || k;
    return k;
  }

  function bauen(img) {
    if (img.dataset.merRubbel) return;
    img.dataset.merRubbel = "1";
    var knopf = weiterKnopf(img);
    var knopfBlock = knopf && (knopf.closest(".mer-rubbel-weiter") || knopf);
    if (knopfBlock) knopfBlock.style.display = "none";
    var huelle = img.parentElement;
    if (getComputedStyle(huelle).position === "static") huelle.style.position = "relative";

    var GEWINN = KARTEN[img.alt];
    var cv = document.createElement("canvas");
    cv.setAttribute("aria-label", "Rubbelkarte – mit dem Finger freirubbeln");
    cv.style.cssText = "position:absolute;z-index:2;touch-action:none;cursor:grab;transition:opacity .6s ease;" +
      "-webkit-user-select:none;user-select:none;-webkit-tap-highlight-color:transparent";
    huelle.appendChild(cv);
    var ctx = cv.getContext("2d");
    var folie = new Image();
    var raster = new Uint8Array(RASTER_X * RASTER_Y), frei = 0, fertig = false, gestartet = false;
    var letzter = null, dpr = Math.max(1, window.devicePixelRatio || 1);

    function lage() {                                   // Canvas deckungsgleich aufs Bild
      var h = huelle.getBoundingClientRect(), r = img.getBoundingClientRect();
      cv.style.left = (r.left - h.left) + "px"; cv.style.top = (r.top - h.top) + "px";
      cv.style.width = r.width + "px"; cv.style.height = r.height + "px";
      cv.style.borderRadius = getComputedStyle(img).borderRadius;
      return r;
    }
    function malen() {
      var r = lage();
      if (!r.width || !folie.complete || !folie.naturalWidth) return;
      cv.width = Math.round(r.width * dpr); cv.height = Math.round(r.height * dpr);
      ctx.globalCompositeOperation = "source-over";
      ctx.drawImage(folie, 0, 0, cv.width, cv.height);
      ctx.globalCompositeOperation = "destination-out";
      ctx.lineCap = ctx.lineJoin = "round";
      raster.fill(0); frei = 0;
    }
    folie.onload = function () {
      malen();
      if (GEWINN) img.src = GEWINN;                    // darunter liegt jetzt der Gewinn
    };
    folie.src = img.currentSrc || img.src;
    if (window.ResizeObserver) new ResizeObserver(function () { if (!gestartet) malen(); else lage(); }).observe(img);

    function punkt(e) {
      var r = cv.getBoundingClientRect();
      return { x: (e.clientX - r.left) / r.width, y: (e.clientY - r.top) / r.height };
    }
    function zaehlen(p, rad) {                          // Rasterzellen unter dem Pinsel als frei markieren
      var rx = rad * RASTER_X, ry = rad * RASTER_Y;
      for (var gy = Math.max(0, Math.floor(p.y * RASTER_Y - ry)); gy <= Math.min(RASTER_Y - 1, Math.floor(p.y * RASTER_Y + ry)); gy++)
        for (var gx = Math.max(0, Math.floor(p.x * RASTER_X - rx)); gx <= Math.min(RASTER_X - 1, Math.floor(p.x * RASTER_X + rx)); gx++) {
          var dx = (gx + 0.5) / RASTER_X - p.x, dy = ((gy + 0.5) / RASTER_Y - p.y) * cv.height / cv.width;
          if (dx * dx + dy * dy <= rad * rad && !raster[gy * RASTER_X + gx]) { raster[gy * RASTER_X + gx] = 1; frei++; }
        }
    }
    function flitter(e) {                               // kleine Goldflocken, die abfallen
      if (Math.random() > 0.35) return;
      var h = huelle.getBoundingClientRect(), f = document.createElement("span");
      var g = 3 + Math.random() * 4, dx = (Math.random() - 0.5) * 60;
      f.style.cssText = "position:absolute;z-index:3;pointer-events:none;border-radius:1px;width:" + g + "px;height:" + g + "px;" +
        "left:" + (e.clientX - h.left) + "px;top:" + (e.clientY - h.top) + "px;" +
        "background:linear-gradient(135deg,#f3dc9a,#b8913f);transition:transform .7s cubic-bezier(.3,.6,.6,1),opacity .7s";
      huelle.appendChild(f);
      requestAnimationFrame(function () {
        f.style.transform = "translate(" + dx + "px," + (40 + Math.random() * 50) + "px) rotate(" + (Math.random() * 360) + "deg)";
        f.style.opacity = "0";
      });
      setTimeout(function () { f.remove(); }, 750);
    }
    function rubbeln(e) {
      var p = punkt(e), rad = Math.max(18, Math.min(34, cv.width / dpr * 0.07)) / (cv.width / dpr);
      ctx.lineWidth = rad * 2 * cv.width;
      ctx.beginPath();
      if (letzter) { ctx.moveTo(letzter.x * cv.width, letzter.y * cv.height); ctx.lineTo(p.x * cv.width, p.y * cv.height); ctx.stroke(); }
      else { ctx.arc(p.x * cv.width, p.y * cv.height, rad * cv.width, 0, Math.PI * 2); ctx.fill(); }
      if (letzter) {                                     // Zwischenpunkte zählen, damit schnelle Striche nicht Lücken lassen
        var n = Math.ceil(Math.hypot(p.x - letzter.x, p.y - letzter.y) / (rad * 0.5));
        for (var i = 1; i <= n; i++) zaehlen({ x: letzter.x + (p.x - letzter.x) * i / n, y: letzter.y + (p.y - letzter.y) * i / n }, rad);
      } else zaehlen(p, rad);
      letzter = p;
      flitter(e);
      if (!fertig && frei / raster.length >= FERTIG_AB) aufdecken();
    }
    function aufdecken() {
      fertig = true;
      cv.style.opacity = "0"; cv.style.pointerEvents = "none";
      if (navigator.vibrate) navigator.vibrate([12, 40, 12]);
      setTimeout(function () { cv.remove(); var k = weiterKnopf(img); if (k) k.click(); else img.click(); }, 1700);
    }
    function halt(e) { e.stopPropagation(); }           // kein Klaviyo-Klick, solange gerubbelt wird
    cv.addEventListener("click", function (e) { halt(e); e.preventDefault(); });
    cv.addEventListener("pointerdown", function (e) {
      halt(e); e.preventDefault();
      if (fertig) return;
      gestartet = true; letzter = null;
      cv.style.cursor = "grabbing";
      try { cv.setPointerCapture(e.pointerId); } catch (x) {}
      rubbeln(e);
    });
    cv.addEventListener("pointermove", function (e) {
      if (letzter && !fertig) { halt(e); e.preventDefault(); rubbeln(e); }
    });
    ["pointerup", "pointercancel"].forEach(function (t) {
      cv.addEventListener(t, function (e) { halt(e); letzter = null; cv.style.cursor = "grab"; });
    });
    ["mousedown", "touchstart"].forEach(function (t) { cv.addEventListener(t, halt, { passive: true }); });
  }

  function suchen() {
    var bilder = document.querySelectorAll(Object.keys(KARTEN).map(function (a) {
      return 'img[alt="' + a + '"]:not([data-mer-rubbel])';
    }).join(","));
    for (var i = 0; i < bilder.length; i++) {
      (function (img) {
        if (img.complete && img.naturalWidth) bauen(img);
        else img.addEventListener("load", function () { bauen(img); }, { once: true });
      })(bilder[i]);
    }
  }
  suchen();
  new MutationObserver(suchen).observe(document.documentElement, { childList: true, subtree: true });
})();
